export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-5xl mx-auto">
          <div className="flex-1 w-full max-w-sm lg:max-w-none">
            <div className="relative w-full aspect-[3/4] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20manga%20reading%20app%20interface%20with%20vertical%20scrolling%20comic%20panels%2C%20warm%20lighting%2C%20clean%20minimal%20phone%20on%20a%20wooden%20desk%20surface%2C%20cozy%20atmosphere%20with%20soft%20natural%20light%2C%20illustration%20style%2C%20warm%20coral%20accents%2C%20no%20readable%20text%2C%20artistic%20rendering&width=600&height=800&seq=app-manga-02&orientation=portrait"
                alt="迷妹漫画移动端阅读体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1.5 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-semibold tracking-wide mb-4 whitespace-nowrap">
              随时随地看漫画
            </span>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-4">
              移动端流畅阅读
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              迷妹漫画支持手机浏览器直接访问，无需下载 App 也能享受流畅的下拉式漫画阅读体验。竖屏连续滚动，翻页无延迟，完美适配移动端屏幕。在地铁上、午休时、睡前床头上，随时打开迷妹漫画网，完结漫画大全尽在掌中。收藏本页到手机桌面，就能像使用原生 App 一样快速访问所有漫画全集和漫画完整版资源。
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 text-xs md:text-sm text-foreground-600 bg-background-100 px-4 py-2 rounded-full">
                <i className="ri-smartphone-line text-primary-500 text-base"></i>
                <span>手机浏览器即开即看</span>
              </div>
              <div className="flex items-center gap-2 text-xs md:text-sm text-foreground-600 bg-background-100 px-4 py-2 rounded-full">
                <i className="ri-scroll-to-bottom-line text-primary-500 text-base"></i>
                <span>下拉式连续滚动</span>
              </div>
              <div className="flex items-center gap-2 text-xs md:text-sm text-foreground-600 bg-background-100 px-4 py-2 rounded-full">
                <i className="ri-bookmark-line text-primary-500 text-base"></i>
                <span>收藏到桌面快捷访问</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}